(function () {
    'use strict';

    angular
        .module('rms.common')
        .controller('RecruitmentSelectionController', RecruitmentSelectionController);

    function RecruitmentSelectionController($scope, lodash, GenericModel, $q, ActionManager, $timeout) {
        const panelCtrl = getPanelCtrl($scope);
        const panelState = lodash.get(panelCtrl, 'panelState', null);
        const panelOption = lodash.get(panelState, 'structure.options', null);
        const panelModel = lodash.get(panelState, 'model', null);
        const panelForm = lodash.get(panelState, 'structure.component', null);


        // load preferred ds
        panelState.loading = true;
        $q.all([
            loadDs('preferredListing', panelOption.preferred_listing.datasource),
            loadDs('companyListing', panelOption.company_listing.datasource)
        ]).then(function (test) {
            $timeout(function () {
                panelState.loading = false;
            });
        });

        panelState.events = {
            select: select,
            isSelected: isSelected,
            getPreferredItem: getPreferredItem,
            getCompanyItem: getCompanyItem,
            getCompanyEmailItem: getCompanyEmailItem,
            removeContact: removeContact,
            removeSelected: removeSelected,
        };

        $scope.$on('$destroy', function () {
            ActionManager('dm-close-dialog', {});
        });

        function select(type, item) {
            // when select, need show dialog. dialog will allow selection of contacts.
            const selected = isSelected(type, item);
            let selected_contacts = null;

            if (type == 'preferred' && selected) {
                return;
            }

            if (type == 'company') {
                if (lodash.isEmpty(item.contacts) && selected) {
                    return;
                }

                const contact_field_name = 'selected_contacts_' + type;
                selected_contacts = lodash.get(panelModel[contact_field_name], item.select_id, []);
            }

            return $q.when(ActionManager('dm-open-dialog', {
                    controller: 'RecruiterSelectionDialogCtrl',
                    templateUrl: 'tms/templates/jobs/recruiter-selection-dialog',
                    dialog_options: {

                        recruiter: lodash.assign(item, {banner_options: panelOption.banner_options}),
                        hideModalHeader: true,
                        selected_contacts: selected_contacts,
                        is_selected: selected,
                        options: panelOption.dialog_options,
                    }
                }),

                function (res) {
                    res.modal.closed.then(function (dialogResult) {
                        if (dialogResult !== false) {
                            addSelected(type, item);
                            if (dialogResult !== true) {
                                addContacts(type, item, dialogResult.selected_contacts);
                            }
                        }
                    });
                }
            )
                ;
        }

        function isSelected(type, item) {
            const field_name = 'selected_' + type;
            const existingValue = lodash.get(panelModel, field_name, []);
            const filtered = lodash.filter(existingValue, function (_item) {
                return _item.select_id === item.select_id;
            });
            return filtered.length > 0;
        }

        function addSelected(type, provider) {
            const field_name = 'selected_' + type;
            const existingValue = lodash.get(panelModel, field_name, []);
            const filtered = lodash.filter(existingValue, function (_item) {
                return _item.select_id === provider.select_id;
            });
            if (filtered.length > 0) {
                return;
            }

            if (!panelModel[field_name]) {
                panelModel[field_name] = [];
            }

            panelModel[field_name].push({
                id: provider.id,
                select_id: provider.select_id,
            });
        }

        function removeSelected(type, provider) {
            const field_name = 'selected_' + type;
            const contact_field_name = 'selected_contacts_' + type;
            const existingValue = lodash.get(panelModel, field_name, []);

            panelModel[field_name] = lodash.filter(existingValue, function (_item) {
                return _item.select_id !== provider.select_id;
            });
            delete panelModel[contact_field_name][provider.select_id];
        }

        function addContacts(type, provider, contacts) {
            const contact_field_name = 'selected_contacts_' + type;
            if (!panelModel[contact_field_name]) {
                panelModel[contact_field_name] = {};
            }
            panelModel[contact_field_name][provider.select_id] = contacts.map(function (_contact) {
                return {
                    id: _contact.id,
                    select_id: _contact.select_id,
                }
            });
        }

        function removeContact(type, provider, contact) {
            const contact_field_name = 'selected_contacts_' + type;
            panelModel[contact_field_name][provider.select_id] = lodash.filter(panelModel[contact_field_name][provider.select_id], function (_contact) {
                return _contact.select_id != contact.select_id;
            });
        }

        function getPreferredItem(item) {
            if (lodash.has(panelState, 'preferredListing')) {
                return lodash.find(panelState.preferredListing, {select_id: item.select_id});
            }
            return null;
        }

        function getCompanyItem(item) {
            if (lodash.has(panelState, 'companyListing')) {
                return lodash.find(panelState.companyListing, {select_id: item.select_id});
            }
            return null;
        }

        function getCompanyEmailItem(provider, email) {
            return lodash.find(provider.contacts, {
                select_id: email.select_id,
            });
        }

        function loadDs(name, _datasource) {
            const url = lodash.get(_datasource, 'url');
            const method = lodash.get(_datasource, 'method', 'get');
            const model = new GenericModel(url);
            const promise = model[method]().$promise.then(function (res) {
                panelState[name] = res.rows;
                return res.rows;
            });
            return promise;
        }

        function getPanelCtrl(_scope) {
            const _vm = lodash.get(_scope, 'vm', null);
            if (!!_vm && _vm.constructor.name == 'asyncPanelCtrl') {
                return _vm;
            }
            if (lodash.has(_scope, '$parent')) {
                return getPanelCtrl(_scope.$parent);
            }
            return null;
        }
    }
})();